export default __webpack_public_path__ + "images/qa-90240e607800ce7ed1bdf42b580695bc.svg";